import Request from "@services/request";

const UploadFile = async ({ id, file }: { id: number; file: File }) => {
    const formData = new FormData();

    formData.append("image", file);

    return await new Request().post<
        FormData,
        IReturnValue<{
            url: string;
        }>
    >(
        {
            base: "ARTICLE_THUMBNAIL",
            params: {
                id,
            },
        },
        formData,
    );
};

// Main Object
const ArticleThumbnailApis = {
    UploadFile,
};

export default ArticleThumbnailApis;
